export const closeModal = ({ commit }) => {
    commit('setOpenedModal', null);
    commit('setOpenedModalPayload', null);
};